import React, { useCallback } from "react";
import { Button } from "reactstrap";
import { appendQueryParams } from "../../util/api";

export const AdministrateExportButton = ({ exportUrl, filters, ...rest }) => {
  const getExportUrl = useCallback(() => {
    const params = { ...filters, page: 1, per: 1000 };
    return appendQueryParams(exportUrl, params);
  }, [exportUrl, filters]);

  return (
    <Button onClick={() => window.open(getExportUrl())} download {...rest}>
      Export
    </Button>
  );
};
